import { AxiosInstance } from 'axios';
import { TApiResponse } from '@type/common';
import {
  TGetContractsExtensionOrdersParams,
  TGetContractsExtensionOrdersResponse,
} from './type';

export default (axios: AxiosInstance, apiPrefix: string) => ({
  /**
   * @description 取得合約展延訂單
   */
  getContractsExtensionOrders(
    params: TGetContractsExtensionOrdersParams,
  ): TApiResponse<TGetContractsExtensionOrdersResponse> {
    return axios.get(`${apiPrefix}/backend/contracts-extension`, {
      params,
    });
  },
});
